import React from "react";

const ReportItemList = ({ data, setSem, activeSem }) => {
  const getItemTitle = (item) => {
    return  `${item.class_desc} ( ${item.entry_year} ) `;
  };

  const renderClass = (item) => {
    let _data = getItemTitle(data.data[[activeSem]]);
    let _item = getItemTitle(item);

    return _item === _data ? "active" : "";
  };
  return (
    <div className="report-item-list">
      <ul>
        {data?.data?.map((sem, i) => (
          <li key={i} onClick={() => setSem(i)} className={renderClass(sem)}>
            {getItemTitle(sem)}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ReportItemList;
